import { ViewStream } from "spyne";
import { UIFooterView } from "components/ui/ui-footer-view";

export class PageCardExpandedView extends ViewStream {
  constructor(props = {}) {
    props.tagName = "article";
    props.class = "expanded-content";
    props.template = require("./templates/page-card-expanded.tmpl.html");
    super(props);
  }

  addActionListeners() {
    return [["CHANNEL_APP_ROUTE_.*_EVENT", "onSecondaryPageEvent"]];
  }

  onSecondaryPageEvent() {
    this.disposeViewStream();
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {
    const addFigureCaption = () => {
      const figureContent = new ViewStream({
        tagName: "figcaption",
        class: "reveal",
        template: `<p>${this.props.data.headline}</p>`,
      });

      this.appendViewToParentEl(figureContent, ".card-image", 2);
    };

    const addFooter = () => {
      const cardMode = true;
      this.appendViewToParentEl(new UIFooterView({ cardMode }));
    };

    const addRevealClass = () => {
      addFigureCaption();
      addFooter();
      this.props.el$.addClass("reveal");
    };

    requestAnimationFrame(addRevealClass);

    this.addChannel("CHANNEL_APP_ROUTE", true);
  }
}
